import AuthLayout from "components/Layout/newAuth/AuthLayout"
import ResetPassword from "components/page_components/auth/ResetLink/ResetPassword"
import { ResetPasswordProvider } from "context/ResetPasswordContext"
import { NextSeo } from "next-seo"

export default function ForgotPasswordPage() {
    return (
        <>
            <NextSeo noindex nofollow />
            <AuthLayout>
                <ResetPasswordProvider>
                    <ResetPassword />
                </ResetPasswordProvider>
            </AuthLayout>
        </>
    )
}
